import { useMatch } from 'react-router-dom'

import { decodeResourcePath } from './explorer-paths'

export type ExplorerRouteSelection =
  | { kind: 'none' }
  | { kind: 'folder'; path: string }
  | { kind: 'item'; path: string }

/**
 * Read the explorer selection from the matched path route.
 * Folder routes (`…/f/*`) are checked before item routes so a folder
 * path is never misread as a leaf.
 */
export function useExplorerSelection(surface: 'dashboards' | 'templates'): ExplorerRouteSelection {
  const base = surface === 'templates' ? '/dashboards/templates' : '/dashboards'
  const folderMatch = useMatch({ path: `${base}/f/*`, end: true })
  const itemMatch = useMatch({ path: `${base}/*`, end: true })

  if (folderMatch) {
    return {
      kind: 'folder',
      path: decodeResourcePath(folderMatch.params['*'])
    }
  }

  if (itemMatch) {
    const path = decodeResourcePath(itemMatch.params['*'])
    if (path === '') return { kind: 'none' }
    // Reserved segments under /dashboards — should be handled by sibling
    // routes, but guard so a bad match never looks like a dashboard path.
    if (
      surface === 'dashboards' &&
      (path === 'templates' ||
        path.startsWith('templates/') ||
        path === 'autogenerate' ||
        path.startsWith('autogenerate/') ||
        path === 'f' ||
        path.startsWith('f/'))
    ) {
      return { kind: 'none' }
    }
    if (surface === 'templates' && (path === 'f' || path.startsWith('f/'))) {
      return { kind: 'none' }
    }
    return { kind: 'item', path }
  }

  return { kind: 'none' }
}
